import { StateColor } from "styles/themeColors";

export const BASE_PADDING = "0.5rem";
export const BASE_PADDING_LARGE = "1rem";

export const MOBILE_BREAKPOINT = "768px";

export const STATE_COLOR_OPTIONS: StateColor[] = [
  "primary",
  "success",
  "warning",
  "error",
  "info",
  "neutral",
];
